import { styled, css } from 'styled-components';

export const Container = styled.div<{ $hasSelection?: boolean; $view: CalendarView }>`
  ${({ theme: { colors }, $hasSelection, $view }) => css`
    overflow-x: hidden;
    position: relative;
    /* Reserves room for the floating bulk-actions bar (fixed, bottom: 24px, outside this
       scroll container) so it doesn't sit on top of the last row's content. */
    padding-bottom: ${$hasSelection ? '5rem' : 0};

    ${
      $view === 'monthly' &&
      css`
        height: calc(100svh - var(--banner-height) - 8.75rem);
        overflow-y: auto;
      `
    }

    ${
      $view === 'weekly' &&
      css`
        height: calc(100svh - var(--banner-height) - 16rem);
        overflow-y: hidden;
      `
    }

    ${
      $view === 'daily' &&
      css`
        height: calc(100svh - var(--banner-height) - 8.5rem);
        overflow-y: hidden;

        .heading {
          display: none;
        }
      `
    }

    * {
      box-sizing: border-box;
    }

    @media print {
      height: 100% !important;
      overflow-y: visible !important;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }

      ${
        $view !== 'daily' &&
        css`
          border-top: 2px solid ${colors.brandPrimary};
        `
      }

      ${
        $view === 'daily' &&
        css`
          .heading {
            border-bottom: 2px solid ${colors.brandPrimary};
            display: block;
            padding-bottom: 0.5rem;
          }
        `
      }
    }
  `}
`;
